export const TYPE_VISUEL = 'Visuel';
export const TYPE_IMPRESSION = 'Impression';
export const TYPE_FACONNAGE = 'Faconnage';
export const TYPE_EXPEDITION = 'Expedition';
export const ACTION_GENERATION_COMMANDE_ACHAT = 'GENERATION_COMMANDE_ACHAT';
export const ETAT_TYPE_GENERE = 'Genere';
export const ETAT_TYPE_COMMANDE = 'Commande';
export const ETAT_TYPE_RECEPTIONNE = 'Receptionne';
export const ETAT_TYPE_RECEPTIONNE_PARTIELLEMENT = 'ReceptionnePartiellement';
export const ACTION_EDIT_BESOIN = 'EDITION_BESOIN_MASSE';

export const ETATS_BESOIN = [
  { code: ETAT_TYPE_GENERE, libelle: 'besoin.etat.genere' },
  { code: ETAT_TYPE_COMMANDE, libelle: 'besoin.etat.commande' },
  { code: ETAT_TYPE_RECEPTIONNE_PARTIELLEMENT, libelle: 'besoin.etat.receptionnePartiellement' },
  { code: ETAT_TYPE_RECEPTIONNE, libelle: 'besoin.etat.receptionne' },
];
